import { UserState } from "@/vuex/modules/user/user.types";

export const state: UserState = {
  users: [],
  loading: false,
  pagination: null,
  currentUser: null,
  pharmacistInfo: null,
  pharmacistInfoFetched: false,
  disabledMode: false
};
